import { isGuestUser, isGuestUserfun } from '@/utils';
import { useCallback } from 'react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';

/** TODO: replace with the real account (or set VITE_INSTAGRAM_URL). */
export const PLACEHOLDER_INSTAGRAM_URL = 'https://www.instagram.com/krown1x';

type UseContactSupportOptions = {
  initialMessage?: string;
};

export const useContactSupport = (options?: UseContactSupportOptions) => {
  const isGuest = isGuestUser();
  const supportInfo = useSelector((state: any) => state.user.supportInfo);
  const { whatsapp, telegram } = supportInfo ?? {};
  // The support API has no Instagram field yet; fall back to the build-time link, then a
  // placeholder until the real account is known.
  const instagram: string | null =
    supportInfo?.instagram || import.meta.env.VITE_INSTAGRAM_URL || PLACEHOLDER_INSTAGRAM_URL;
  const handleWhatsAppSupportClick = useCallback(() => {
    // if (isGuestUserfun()) {
    //   toast.error('Please login to contact our support team.', { id: 'support' });
    //   return;
    // }

    if (!whatsapp) {
      toast.error('WhatsApp support is currently unavailable.', { id: 'support' });
      return;
    }

    const text = encodeURIComponent(options?.initialMessage ?? 'Hello, I need assistance.');

    window.open(`${whatsapp}?text=${text}`, '_blank');
  }, [supportInfo, isGuest, options?.initialMessage]);

  const handleTelegramSupportClick = useCallback(() => {
    // if (isGuestUserfun()) {
    //   toast.error('Please login to contact our support team.', { id: 'support' });
    //   return;
    // }

    if (!telegram) {
      toast.error('Telegram support is currently unavailable.', { id: 'support' });
      return;
    }

    window.open(telegram, '_blank');
  }, [supportInfo, isGuest]);

  const handleInstagramSupportClick = useCallback(() => {
    if (!instagram) {
      toast.error('Instagram support is currently unavailable.', { id: 'support' });
      return;
    }

    window.open(instagram, '_blank');
  }, [instagram]);

  return {
    whatsapp: supportInfo?.whatsapp ?? null,
    telegram: supportInfo?.telegram ?? null,
    instagram,
    handleWhatsAppSupportClick,
    handleTelegramSupportClick,
    handleInstagramSupportClick,
  };
};

export default useContactSupport;
